import {
  DialogTrigger,
  GhostIconButton,
  Popover,
  PopoverContent,
  Text,
  SectionSubHeading,
} from "@certn/cascadia-react";
import { RenderContext } from "@certn/cascadia-react/context/RenderContext";
import { css } from "@emotion/css";
import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React, { PropsWithChildren, useContext } from "react";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";

export function SectionSubheadingControl(props: ControlProps) {
  const options = props.uischema.options || {};
  const { t } = useTranslation();
  const isPDF = useContext(RenderContext).isForPdfGeneration;

  const data = props.data;

  const textWrapper = (props: PropsWithChildren) => {
    return <Text className={styles.popoverContent}>{props.children}</Text>;
  };

  return (
    <SectionSubHeading
      title={
        props.uischema.label
          ? props.uischema.label.toString()
          : (data?.title ?? data ?? "").toString()
      }
      detailText={data?.detail_text?.toString() ?? options.detailText}
      detailTextColor={options.detailTextColor}
      isCollapsible={options.isCollapsible}
      isOpen={options.isOpen}
      tooltip={
        options.popoverContent &&
        !isPDF && (
          <DialogTrigger>
            <GhostIconButton
              icon="info"
              testID="text-display-info-button"
              aria-label={t("Additional information")}
              className={styles.popoverIcon}
            />
            <Popover placement="top">
              <PopoverContent>
                <Markdown
                  components={{
                    p: textWrapper,
                  }}
                >
                  {options.popoverContent}
                </Markdown>
              </PopoverContent>
            </Popover>
          </DialogTrigger>
        )
      }
    />
  );
}

const styles = {
  popoverIcon: css({
    width: "1.1rem",
    height: "1.1rem",
    "& i": {
      color: "var(--icon-weak)",
    },
  }),
  popoverContent: css({ color: "var(--text-weak)" }),
};

export const SectionSubheadingRenderer = withJsonFormsControlProps(
  SectionSubheadingControl
);
